// removed by extract-text-webpack-plugin
module.exports = {"audioGuideListItem":"_1fQwjTcliymy4Oa6VAh6ii","header":"_2gNwoUYT6lWYu2y7bRHVz-","audioGuideListItemInfo":"_1mcncfbkoXvc0SCYmcYi3L","subHeader":"_2gMPSEhtuhuLza0mIaD7fv","coverImage":"_351pz7lkbpql2wbpTBlA6G"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AudioGuideComponents/AudioGuidesListItem/AudioGuidesListItem.css
// module id = 475
// module chunks = 8